<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            small
            text
            icon
            color="primary"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <span>Change Base Location</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Base Location"
      text="Change Base Location"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="state"
                :items="states"    
                item-text="name"
                item-value="id"
                value="id"
                label="State"
                hide-no-data
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="localCity.city_id"
                v-validate="'required'"
                :items="cityList" 
                data-vv-name="employee.city_id"
                data-vv-as="city"   
                item-text="name"
                item-value="id"
                value="id"
                label="City"
                hide-no-data
                hide-selected
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      employee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        city: '',
        cities: [],
        dialog: null,
        progressing: false,
        localCity: null,
        state: '',
        states: [],
      }
    },
    computed: {
      cityList () {
        return this.cities.filter(city => {
          if (this.state) {
            return city.state_id === this.state
          }
          return city
        })
      },
      isCityChanged () {
        return this.localCity.city_id !== this.employee.city_id
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadCity()
          this.loadState()
          this.localCity = { ...this.employee }
          if (this.localCity.city) {
            this.state = this.localCity.city.state_id
          }
        }
      },
    },
    methods: {
      loadCity () {
        this.$api.cities().list()
          .then((res) => {
            this.cities = res.data
          })
          .catch(() => {})
      },
      loadState () {
        this.$api.states().list()
          .then((res) => {
            this.states = res.data
          })
          .catch(() => {})
      }, 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)
            if (this.isCityChanged) {
              Promise.all([
                this.$api.employees().update(this.employee.employee_uid, this.prepareFormData()),
                this.$api.employeeCities().create(this.employee.employee_uid, this.prepareFormData()),
              ])
                .then(([employee, employeeCities]) => {
                  if (employee.status === 200 && employeeCities.status === 201) {
                    this.$emit('updated')
                    this.$snack({ message: employee.data.status })

                    this.dialog = false
                  }
                })
                .catch(() => {})
                .then(() => {
                  this.dialog = false
                  this.setProgressing(false)
                })
            } else {
              this.$snack({ message: 'No update has been done' })
              this.setProgressing(false)
              this.dialog = false
            }
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          city_id: this.localCity.city_id,
        }
      },
    },
  }
</script>
